import { render, staticRenderFns } from "./InvoiceProjectCard.vue?vue&type=template&id=68cee4c2&scoped=true"
import script from "./InvoiceProjectCard.vue?vue&type=script&lang=js"
export * from "./InvoiceProjectCard.vue?vue&type=script&lang=js"
import style0 from "./InvoiceProjectCard.vue?vue&type=style&index=0&id=68cee4c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cee4c2",
  null
  
)

export default component.exports